import React, {useState, useEffect} from 'react';
import { List, Badge } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import './adpackagecard.scss';

const AdPackageTable = (props) => {
  const { loading, data, selectedItem, onSelect } = props;

  const [select, setSelect] = useState(selectedItem || "");

  const onSelectChange = (e) => {
    if(onSelect){
        onSelect(e);
      }
      setSelect(e._id);
  }

  useEffect(() => {
     setSelect(selectedItem);
   }, [selectedItem]);

  return (
    <List
        pagination = {false}
        loading={loading?{indicator:<LoadingOutlined style={{ fontSize: 24 }} spin />}:false}
        className="adpackagetable"
        size="small"
        dataSource={data.sort((a, b) => {
          if ((a.status === 'active' || !a.status) && b.status === 'inactive') {
            return -1; // "active" comes before "inactive"
          } else if (a.status === 'inactive' && (b.status === 'active' || !b.status)) {
            return 1; // "inactive" comes after "active"
          } else {
            return 0; // no change in order
          }
        })}
        renderItem={(item) =>
          <div className={`row ${onSelect?'select':''} ${select && select._id === item._id?'selected':''}`} onClick={onSelectChange.bind(this,item)}>
              <span className="item1">{item.title}</span>
              <div>
              {
                item.status !== 'inactive' ?
                <Badge status="success" text="Active" />
                :
                <Badge status="default" text="Inactive" />
              }
              </div>
          </div>
        }
    />
  );
};

export default AdPackageTable;
